import styled from "styled-components";

export const BoardStyled = styled.div`
  margin-top: -1vh;
`;
